import axios, { AxiosError, AxiosRequestConfig } from "axios";
import { getToken, removeToken } from "Session";
import { Router } from "router-manager/parts";
import { API, APIError } from "services/api-utils/api-creator";
import { makeEvent } from "services/events";

function onRedirectToLogin() {
  apiHigienizacaoJWT.deleteTokens();
  removeToken();
  makeEvent("logout");
  Router.push("/login");
}

export const apiHigienizacaoJWT = new API({
  apiName: "powerhub",
  baseUrl: process.env.REACT_APP_PUBLIC_HIGIENIZACAO || "",
  ignoreAuth: (request) => request.endpoint === "/auth/token",
  onRedirectToLogin,

  async refreshTokenFunction(prevRefreshToken) {
    const api = new API();
    try {
      const { data } = await api.post(
        `https://novapowerhub.com.br/api/auth/refresh?refreshToken=${prevRefreshToken}`
      );
      return {
        newAccessToken: data.access_token,
        newRefreshToken: data.refresh_token
      };
    } catch (e) {
      // e.response?.data?.message ? Ver isso.
      onRedirectToLogin();
      throw e;
    }
  }
});

apiHigienizacaoJWT.useResponseMiddleware(async (response) => {
  // O erro 401 agora é tratado automaticamente no api-creator
  // com retry após refresh do token. Se chegar aqui, significa
  // que o refresh falhou ou não está configurado
  if (response.status === 401) {
    onRedirectToLogin();
    return Promise.reject(new APIError("Sessão expirada"));
  }

  return response;
});

const apiHigienizacao = axios.create({
  baseURL: process.env.REACT_APP_PUBLIC_HIGIENIZACAO,
  headers: { "Content-Type": "application/json" }
});

apiHigienizacao.interceptors.request.use((config: AxiosRequestConfig) => {
  if (config.url !== "/usuarios/login") {
    const token = getToken();
    if (token) {
      if (config.headers) config.headers.Authorization = `Basic ${token}`;
    }
  }
  return config;
});

apiHigienizacao.interceptors.response.use(
  (res: AxiosRequestConfig) => {
    return res;
  },
  (error: AxiosError) => {
    if (
      error.config.url !== "/usuarios/login" &&
      401 === error.response?.status
    ) {
      alert("Sem autorização de acesso!");
      removeToken();
      window.location.href = "/login";
      return Promise.reject(error);
    } else if (
      error.config.url !== "/usuarios/login" &&
      403 === error.response?.status
    ) {
      return Promise.reject(error);
    } else {
      return Promise.reject(error);
    }
  }
);

export default apiHigienizacao;
